<template>
    <page-view title="专家费用支付情况">
        <template slot="action">
            <a-button type="primary" :loading="saveLoading" @click="onSubmit">保存</a-button>
        </template>
        <a-card>
            <a-form-model
                    v-for="expert in form.feedbackList"
                    :model="expert"
                    ref="form"
                    :rules="rules"
                    class="custom pick-100 form-input"
            >
                <a-card>
                    <a-row :gutter="40">
                        <a-col :span="3">
                            <a-form-model-item prop="expertId">
                                <b style="font-size: larger">{{expert.extras.expert_name}}</b>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="4">
                            <a-form-model-item label="是否已支付" prop="feesState">
                                <a-radio-group v-model="expert.feesState">
                                    <a-radio value="1">是</a-radio>
                                    <a-radio value="0">否</a-radio>
                                </a-radio-group>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="4">
                            <a-form-model-item label="专家费用" prop="fees">
                                <a-input-number :min="0" v-model="expert.fees" style="width: 100%"/>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-card>
            </a-form-model>
        </a-card>
    </page-view>
</template>

<script>
import qs from 'qs'
import moment from 'moment'
import { PageView } from '@/layouts'

const rules = {
  feesState: [{ required: true, message: '请选择是否已支付', trigger: 'change' }],
  fees: [{ required: true, message: '专家费用不能为空', trigger: 'blur' }]
}

const defaultForm = { feedbackList: [] }

export default {
  name: 'FeedbackForm',
  components: {
    PageView
  },
  data () {
    return {
      rules,
      id: this.$route.query.id,
      user: this.$ls.get('user'),
      saveLoading: false,
      form: { ...defaultForm }
    }
  },
  created () {
    const that = this
    this.$http.get(
      `/api/1/expertmain/selectExpertApply/get_selectExpertApply.json?id=${this.id}`
    ).then(res => {
      if (res.code !== 200) {
        return
      }
      that.form.feedbackList = res.result.extras.feedbackList.map(item => {
        return { id: item.id, fees: item.fees, feesState: item.feesState, extras: item.extras }
      })
      // console.log(1, that.form)
    })
  },
  methods: {
    async onSubmit () {
      var ifError = false
      await this.$refs.form.forEach(item => {
        item.validate(valid => {
          if (!valid) {
            ifError = true
          }
        })
      })
      if (ifError) {
        return
      }
      const data = { ...this.form }
      // console.log(data)
      // return
      data.feedbackList.map((item) => {
        delete item.extras
      })
      this.saveLoading = true
      const res = await this.$http.post('/api/1/expertmain/selectExpertFeedback/update_selectExpertFeedback.json', data)
      this.saveLoading = false

      if (res.code !== 200) {
        return
      }
      this.$message.success('保存成功')
      this.$router.push({
        path: '/selectExpertApply/view?id=' + this.id
      })
    }
  }
}
</script>

<style lang="less" scoped>
    .process-list /deep/ .title {
        width: 110px;
    }

    .process-list {
        padding-bottom: 16px;
    }

    .textarea {
        height: 80px;
    }

    .hp-title {
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .hp-title div {
        height: 18px;
        border-left: 5px solid dodgerblue;
        width: 15px;
        display: inline-block;
    }

    .hp-title span {
        font-size: 16px;
        font-weight: bold
    }

    .not-null::before {
        /*top: 6px;*/
        /*left: 8px;*/
        color: red;
        content: '*';
        position: absolute;
        margin-left: -7px;
        font-weight: 700;
        line-height: 1.8em;
    }

</style>
